jQuery(function(){

  var toBtnHeight = 0;
  // ★　任意のズレ高さピクセル数を入力　↓
  if($('#toBtnWrap').length){
      toBtnHeight = 55;
  }

  // #で始まるアンカーをクリックした場合に処理
  // ** nopscrクラスが設定されている場合はスクロール処理を行わない
  jQuery('a[href^="#"]:not(.nopscr)').click(function() {

    // オフセット
    var offset = toBtnHeight;
    // スクロールの速度
    var speed = 200; // ミリ秒
    // アンカーの値取得
    var href= jQuery(this).attr("href");
    // #のみ、空欄の場合はスクロールしない
    if ( href == "#" || href == "" ) {
      // イベントのバブリングを止めずに終了
      return;
    }
    // mainの時、ヘッダーは出ていないのでオフセットなし
    if ( href == '#main' ) {
      offset = 0;
    }

    // 空室一覧の「その他○件を表示」で開くときのみスクロールなし
    if ($(this).hasClass("roomMore") && !$(this).hasClass("open")) {
      return false;
    }

    // 移動先を取得
    var target = $( href );
    // 移動先を数値で取得
    var position = target.offset().top - offset; // ※　-offsetでズレの処理
    // スムーズスクロール
    jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;

  });

});